import { GridDataResult } from '@progress/kendo-angular-grid';
import { Component, OnInit, NgZone, ElementRef, ViewContainerRef } from '@angular/core';

import { ServiceItemService } from '@fs/services/service-item';
import { TabOpenService } from '@services/tab-open.service';
import { Tabs } from '@enums/tab.enum';
import { ActionName } from '@shared/enums/action-name';
import { PermissionPipe } from '@shared/pipes/permission';
import { Constants } from '@shared/models/constants';
import { NotificationsService } from '@shared/services/notification';
import { CommonMethods } from "@services/common.method";
import { AuthService } from '@services/auth.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { ProductItemType } from '@fs/enums/common-enums';

declare var SimpleBar: any;

@Component({
  selector: 'app-service-item-view',
  templateUrl: './service-detail.component.html',
  styleUrls: ['./service-detail.component.scss']
})

export class ServiceItemViewComponent implements OnInit {
  private k_grid: any;
  public showBodyLoader: boolean = false;
  public details: any;
  public actionName=ActionName;
  public attachments:GridDataResult={data:[],total:0};
  public materialItems:GridDataResult={data:[],total:0};
  public laborItems:GridDataResult={data:[],total:0};
  public totalMaterialCost=0;
  public totalMaterialPrice=0;
  public totalLaborCost=0;
  public DefaultImagePath =Constants.DefaultImagePaths.Service;
  public totalLaborPrice=0;
  public inputParams: any;
  public tabCounter: number;
  /** used for attachment slider */
  public showAttachmentSlider: boolean = false;
  /** used for attachment slider */
  public slideIndex: number = 0;
  public qbVersion: string = "";
  productItemType = ProductItemType;

  constructor(
    private serviceItemService: ServiceItemService,
    private toastr: NotificationsService,
    private permissionPipe: PermissionPipe,
    private tabOpen: TabOpenService,
    private zone: NgZone,
    private _elementRef: ElementRef,
    private auth: AuthService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef
  ) {
      this.qbVersion = (this.auth.getCompanyQBType()).toLowerCase();
  }

  //#region Life cycle Events
  ngOnInit() {
    this.getServiceItem(Constants.defaultSpinnertimeout);
  }
  //#endregion
  
  //#region Public Methods
  refreshTab() {
    this.getServiceItem(0);
  }
  onExpand() {
    $(document).on("click", ".k-hierarchy-cell>a", function () {
      $(this).parents('.k-master-row').addClass("active");
    });
  }
  onCollapse() {
    $(document).on("click", ".k-hierarchy-cell>a", function () {
      $(this).parents('.k-master-row').removeClass("active");
    });
  }
  reIntializeMaterialScroll() {
    this.zone.runOutsideAngular(() => {
      this.k_grid = new SimpleBar($(this._elementRef.nativeElement).find('.service-item-material-grid .k-grid-aria-root')[0], { autoHide: false });
    });
  }
  reIntializeLaborScroll() {
    this.zone.runOutsideAngular(() => {
      this.k_grid = new SimpleBar($(this._elementRef.nativeElement).find('.service-item-labor-grid .k-grid-aria-root')[0], { autoHide: false });
    });
  }
  checkIsNotImage(dataItem) {
    if (dataItem != null) {
      let fileName = dataItem.FileName;
      if (!CommonMethods.CheckNullOrUndefined(dataItem["ExternalAttachment"])){
        fileName =dataItem["ExternalAttachment"]["AttachmentPath"]; //dataItem["ExternalAttachment"]["FileName"];
      }
      if (fileName != "") {
        let exts = ['.jpg', '.jpeg', '.gif', '.png', '.bmp'];
        if (!this.validExtension(fileName, exts))
          return true;
        else
          return false;
      }
      else {
        if (!CommonMethods.CheckNullOrUndefined(dataItem.FilePath) && dataItem.FilePath.indexOf("https://mpsuitedevstore.blob.core.windows.net") < 0) {
          return true;
        }
      }
    }
    else
      return false;
  }
  openEditServiceItem() {
    if (!this.permissionPipe.transform(ActionName.EditItem)) {
      return
    }
    this.tabOpen.ReplaceTab(
      {
        CurrentTabIndex: this.tabCounter,
        newTabInfo: {
          tabId: Tabs.FsLiteServiceItemEdit,
          params: { ID: this.inputParams.ID },
          tabTitle: 'Service - ' + this.details.ItemNumber
        }
      })
  }
  viewAttachmentSlide(idx: number) {
    this.slideIndex = idx;
    this.showAttachmentSlider = true;
  }
  closeAttachmentSlider() {
    this.showAttachmentSlider = false;
  }
  //#endregion

  //#region Private methods
  private getServiceItem(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    this.showBodyLoader = true;// its true to handle checkbox visibility as they are dependent on this
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter,instantSpinnerTime);
    this.serviceItemService.GetServiceItem(this.inputParams.ID
    ).subscribe(
      response => {
        this.details = response;
        this.attachments = { data: response.Attachments, total: response.Attachments.length };
        this.attachments.data.forEach(x => {
          x.checkIsNotImage = this.checkIsNotImage(x);
          x.IsImage = !x.checkIsNotImage;
          x.UploadedBy = !CommonMethods.CheckNullOrUndefined(x.CreatedByUser) ? x.CreatedByUser["FirstName"] + " " + x.CreatedByUser["LastName"] : "";
        });
        this.materialItems={data:response.MaterialItems,total:response.MaterialItems.length};
        this.laborItems={data:response.LaborItems,total:response.LaborItems.length};
        this.DefaultImagePath =Constants.DefaultImagePaths.Service; // Reset image to default
        this.DefaultImagePath=this.attachments.data.find(x=>x.IsDefaultImage) != undefined ?this.attachments.data.find(x=>x.IsDefaultImage).FilePath:this.DefaultImagePath;
        this.calculateMaterialTotal()
        this.calculateLaborTotal()
            this.showBodyLoader = false;
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        if (!CommonMethods.CheckNullOrUndefined(this.details.Category.FullName)){
          this.details.Category.FullName = this.details.Category.FullName.replace(/\//g, ':');
        }
      }, error => {
        this.toastr.showMultiLineError(error.error.Message, "Error");
        this.showBodyLoader = false;
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      });
  }
  private calculateMaterialTotal() {
    this.totalMaterialCost = 0;
    this.totalMaterialPrice = 0;
    this.materialItems.data.forEach(element => {
      this.totalMaterialCost = this.totalMaterialCost + (element.MaterialItem.Item.StandardCost * element.Quantity);
      this.totalMaterialPrice = this.totalMaterialPrice + ((element.MaterialItem.PriceBookItem.Prices[0]?element.MaterialItem.PriceBookItem.Prices[0].Amount:0) * element.Quantity);
    });
  }
  private calculateLaborTotal() {
    this.totalLaborCost = 0;
    this.totalLaborPrice = 0;
    this.laborItems.data.forEach(element => {
      this.totalLaborCost = this.totalLaborCost + (element.LaborItem.Cost * element.Hours);
      this.totalLaborPrice = this.totalLaborPrice + ((element.LaborItem.PriceBookItem.Prices[0] ? element.LaborItem.PriceBookItem.Prices[0].Amount : 0) * element.Hours);
    });
  }
  private validExtension(input, exts) {
    var fileName = input.toLowerCase();
    return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(fileName);
  }
  //#endregion
}
